import type { ResolverMap } from './ResolverMap'
import type { DashboardTaskCode } from '~/services/api/generated'

const dashboardTaskTitleByCode = {
  CREATE_STORE: 'presentation.dashboardTask.createStoreTitle',
  CREATE_FIRST_MENU: 'presentation.dashboardTask.createFirstMenuTitle',
  SETUP_PARTNER_PAYOUT_ACCOUNT: 'presentation.dashboardTask.setupPartnerPayoutAccountTitle',
  VERIFY_EMAIL: 'presentation.dashboardTask.verifyEmailTitle',
  COMPLETE_STORE_SETUP: 'presentation.dashboardTask.completeStoreSetupTitle',
  UPLOAD_LOGO_COVER: 'presentation.dashboardTask.uploadLogoCoverTitle',
  INVITE_TEAM_MEMBERS: 'presentation.dashboardTask.inviteTeamMembersTitle',
  ADD_ANOTHER_STORE: 'presentation.dashboardTask.addAnotherStoreTitle',
  SET_UP_BRAND: 'presentation.dashboardTask.setUpBrandTitle',
  ACCEPT_MSA: 'presentation.dashboardTask.acceptMsaTitle',
  ENABLE_MFA: 'presentation.dashboardTask.enableMfaTitle'
} satisfies Record<DashboardTaskCode, string>

export const dashboardTaskTitleResolverMap: ResolverMap<DashboardTaskCode> = {
  byCode: dashboardTaskTitleByCode,
  byReason: {},
  genericKey: 'presentation.dashboardTask.genericTitle'
}
